export const PropertyStatus = [
    {
        key: 'Select',
        value: ''
    },
    {
        key: 'Closed',
        value: 'CLSD'
    },
    {
        key: 'Communal',
        value: 'Communal',
    },
    {
        key: 'Occupied',
        value: 'OCCP',
    },
    {
        key: 'Void',
        value: 'VOID',
    },
]